import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { MatButtonModule } from '@angular/material/button';
import { AuthService } from '../../services/auth.service';
import { SpinnerComponent } from '../../../../shared/components/spinner/spinner.component';

@Component({
  selector: 'app-logout',
  standalone: true,
  imports: [MatButtonModule, SpinnerComponent],
  templateUrl: './logout.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './logout.component.scss',
})
export class LogoutComponent implements OnInit {
  error = '';

  constructor(private readonly authService: AuthService) {}

  ngOnInit(): void {
    void this.signOut();
  }

  async signOut(): Promise<void> {
    this.error = '';
    try {
      await this.authService.signOut();
    } catch {
      this.error = 'Unable to complete sign-out. Please try again.';
    }
  }
}
